module.exports = __webpack_public_path__ + "media/wyposazenie/naped@3x-7d67d055.svg";